import { Validators } from '../../../utils/validators';

export const NewBookingForm2 = (
  strings: any,
  bookingConfirmationList: any[] = [],
  captureLoyaltyProgram = false,
  holdReleaseBaseDate: string | Date | null = null,
): any[] => {
  let arr = [
    {
      label: strings.venueConfig_payment_bookingConfirmation,
      value: {},
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'bookingConfirmationBy',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: bookingConfirmationList,
      required: true,
    },
    {
      label: strings.edit_booking_hold_days,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'holdDays',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateInt, message: strings.invalidHoldDaysMsg, max: 1800 },
      ],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      holdReleaseBaseDate,
    },
  ];

  if (captureLoyaltyProgram) {
    arr.push(
      {
        label: strings.LoyaltyProgram,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'section',
        typeValue: '',
        variant: '',
        placeholder: '',
        field: '',
        validators: [],
        responsive: { xs: 12, sm: 12, md: 12, lg: 12 },
        required: false,
      } as any,
      {
        label: strings.name,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'loyaltyName',
        validators: [{ check: Validators.validateString }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: false,
      } as any,
      {
        label: strings.referenceNo,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'loyaltyReferenceNo',
        validators: [{ check: Validators.validateString }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: false,
      } as any,
      {
        label: strings.remark,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'loyaltyRemark',
        validators: [{ check: Validators.validateString }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: false,
      } as any,
    );
  }

  return arr;
};
